import type { FC } from "react";

import { translate } from "app/filters/i18nFilter";
import { objectEntries } from "app/helpers/objects";
import { CountryRadioSelectorEnum } from "app/pages/sales-intelligence/sub-modules/advanced-search/types/base";

import { StyledRadioSelector } from "./styles";

type FilterRadioSelectorProps = {
    selectedRadio: string;
    handleRadioSelect: (id: string) => void;
    availableRadioOptions: Record<string, boolean>;
};
const FilterRadioSelector: FC<FilterRadioSelectorProps> = ({
    selectedRadio,
    handleRadioSelect,
    availableRadioOptions,
}) => {
    const items = objectEntries(CountryRadioSelectorEnum);
    return (
        <StyledRadioSelector
            selected={selectedRadio}
            onSelect={handleRadioSelect}
            items={items.map(([, value]) => {
                return {
                    id: value,
                    text: translate(`si.components.countries_selector.radio.${value}`),
                    disabled: availableRadioOptions[value],
                };
            })}
        />
    );
};

export default FilterRadioSelector;
